import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ProfileProvider } from "./context/ProfileContext";
import Header from "./components/Header";
import OnboardingModal from "./components/OnboardingModal";
import Home from "./pages/Home";
import Chat from "./pages/Chat";
import Stories from "./pages/Stories";
import Quiz from "./pages/Quiz";
import Paths from "./pages/Paths";
import Library from "./pages/Library";
import Careers from "./pages/Careers";
import Impact from "./pages/Impact";
import Today from "./pages/Today";
import Subscribe from "./pages/Subscribe";
import Admin from "./pages/Admin";
import Ecosystem from "./pages/Ecosystem";
import BharatQuest from "./pages/BharatQuest";
import XR from "./pages/XR";
import XRPartners from "./pages/XRPartners";
import ImmersiveLab from "./pages/Immersive";
import ImmersiveExperience from "./pages/ImmersiveExperience";
import ImmersiveFuture from "./pages/ImmersiveFuture";
import ShareStory from "./pages/ShareStory";
import ShareQuiz from "./pages/ShareQuiz";
import MythosLogo, { MYTHOS_URL, MYTHOS_CIN, MYTHOS_CONTACT_URL } from "./components/MythosLogo";

function Footer() {
  return (
    <footer className="mythos-ink-bg mt-12" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-12 grid md:grid-cols-[1fr_auto] gap-8 items-start">
        <div>
          <a
            href={MYTHOS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 mb-4 group"
            data-testid="footer-mythos-link"
            title="Mythos India Studios — visit corporate website"
          >
            <MythosLogo size={40} testid="footer-mythos-logo" />
            <div className="leading-tight">
              <div className="font-mythos text-[10px] tracking-[0.22em] uppercase mythos-gold font-bold group-hover:opacity-80 transition">
                A Mythos India Studios platform
              </div>
              <div className="text-[10px] tracking-[0.14em] uppercase text-[#F4EFE6]/45 font-mono mt-0.5">
                mythosindiastudio.com ↗
              </div>
            </div>
          </a>
          <div className="font-mythos font-extrabold text-2xl text-[#F4EFE6] tracking-tight">EduSphere</div>
          <div className="text-[11px] tracking-[0.22em] uppercase text-[#C9A66B] font-semibold mt-1">
            Explore · Engage · Evolve
          </div>
          <p className="text-sm text-[#F4EFE6]/60 mt-4 max-w-md">
            Stories that teach. Science that delights. 50 hands-on STEM models inside.
            A Mythos India Studios platform — built for learners everywhere.
          </p>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <a href={MYTHOS_CONTACT_URL} target="_blank" rel="noopener noreferrer" className="text-[#F4EFE6]/80 hover:text-[#C9A66B] transition inline-flex items-center gap-1" data-testid="footer-contact">
            Contact us ↗
          </a>
          <a href={MYTHOS_URL} target="_blank" rel="noopener noreferrer" className="text-[#F4EFE6]/80 hover:text-[#C9A66B] transition inline-flex items-center gap-1" data-testid="footer-mythos-website">
            Parent company ↗
          </a>
          <a href="/ecosystem" className="text-[#F4EFE6]/80 hover:mythos-gold hover:text-[#C9A66B] transition" data-testid="footer-ecosystem">Ecosystem</a>
          <a href="/impact" className="text-[#F4EFE6]/80 hover:text-[#C9A66B] transition" data-testid="footer-impact">Impact &amp; investors</a>
          <a href="/subscribe" className="text-[#F4EFE6]/80 hover:text-[#C9A66B] transition" data-testid="footer-subscribe">Daily digest</a>
          <a href="/careers" className="text-[#F4EFE6]/80 hover:text-[#C9A66B] transition" data-testid="footer-careers">Careers paths</a>
        </div>
      </div>
      <div className="border-t mythos-rule">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-5 flex flex-wrap gap-3 items-center justify-between text-xs text-[#F4EFE6]/45">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>© {new Date().getFullYear()} <a href={MYTHOS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A66B] transition" data-testid="footer-copyright-link">Mythos India Studios Private Limited</a>. All rights reserved.</span>
            <span className="font-mono opacity-75" data-testid="footer-cin">CIN: {MYTHOS_CIN}</span>
          </div>
          <div className="font-mythos tracking-[0.18em] uppercase">India's intelligence, reimagined.</div>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <ProfileProvider>
        <BrowserRouter>
          <Header />
          <OnboardingModal />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/today" element={<Today />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/stories" element={<Stories />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/paths" element={<Paths />} />
              <Route path="/library" element={<Library />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/ecosystem" element={<Ecosystem />} />
              <Route path="/bharat-quest" element={<BharatQuest />} />
              <Route path="/xr" element={<XR />} />
              <Route path="/xr/partners" element={<XRPartners />} />
              <Route path="/immersive" element={<ImmersiveLab />} />
              <Route path="/immersive/future" element={<ImmersiveFuture />} />
              <Route path="/immersive/:slug" element={<ImmersiveExperience />} />
              <Route path="/share/story/:id" element={<ShareStory />} />
              <Route path="/share/quiz/:id" element={<ShareQuiz />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </ProfileProvider>
    </div>
  );
}
